(function () {
  "use strict";

  function readData() {
    var node = document.getElementById("ZenhomeProductData");
    if (!node) return null;
    try {
      return JSON.parse(node.textContent || "{}");
    } catch (error) {
      console.warn("Zenbodi home product data could not be parsed", error);
      return null;
    }
  }

  var data = readData();
  if (!data || !data.products) return;

  function productFor(card) {
    if (!card) return null;
    return data.products[card.getAttribute("data-product-key")];
  }

  function selectedVariant(card) {
    var product = productFor(card);
    if (!product || !product.variants) return null;
    var key = card.getAttribute("data-selected-variant-key") || product.defaultVariant;
    return product.variants[key] || product.variants[product.defaultVariant];
  }

  function selectedPlan(card) {
    var selected = card && card.querySelector("[data-plan-group] .plan-opt.is-selected");
    return selected ? selected.getAttribute("data-plan") : "once";
  }

  function resolveCartVariant(variant, planMode) {
    if (!variant) return null;
    if (variant.plans) {
      // ZenBean (29 Sep 2026): once / buy3 / buy6, same offer as the landing pages.
      return variant.plans[planMode] || variant.plans.once || null;
    }
    return variant;
  }

  function updateCard(card) {
    var product = productFor(card);
    var variant = selectedVariant(card);
    if (!product || !variant) return;

    var image = card.querySelector("[data-img]");
    if (image && variant.image) image.setAttribute("src", variant.image);

    var link = card.querySelector(".pc-img[href]");
    if (link && variant.url) link.setAttribute("href", variant.url);

    if (variant.plans) {
      Object.keys(variant.plans).forEach(function (key) {
        var planData = variant.plans[key];
        if (!planData) return;
        card.querySelectorAll('[data-plan-price="' + key + '"]').forEach(function (node) {
          node.textContent = planData.price || "";
        });
        card.querySelectorAll('[data-plan-compare="' + key + '"]').forEach(function (node) {
          node.textContent = planData.compare && planData.compare !== planData.price ? planData.compare : "";
        });
        var hasValue = !!(planData.compare && planData.compare !== planData.price);
        card.querySelectorAll('[data-plan-value="' + key + '"]').forEach(function (node) { node.hidden = !hasValue; });
        card.querySelectorAll('[data-plan-label="' + key + '"]').forEach(function (node) { node.textContent = planData.label || ""; });
        card.querySelectorAll('[data-plan-meta="' + key + '"]').forEach(function (node) { node.textContent = planData.meta || ""; });
        card.querySelectorAll('[data-plan-tag="' + key + '"]').forEach(function (node) {
          node.textContent = planData.tag || "";
          node.hidden = !planData.tag;
        });
      });
    } else {
      card.querySelectorAll("[data-sub-price]").forEach(function (node) {
        node.textContent = variant.subPrice || variant.price || "";
      });
      card.querySelectorAll("[data-once-price]").forEach(function (node) {
        node.textContent = variant.price || "";
      });
    }
  }

  function setButtonState(button, state, label) {
    if (!button) return;
    button.classList.remove("is-loading", "is-added", "is-error");
    if (state) button.classList.add(state);
    if (label) button.textContent = label;
  }

  function requestJson(url, options) {
    return fetch(url, options).then(function (response) {
      return response.json().then(function (json) {
        if (!response.ok) {
          var message = json && json.description ? json.description : "Cart request failed.";
          throw new Error(message);
        }
        return json;
      });
    });
  }

  function lineFor(product, variant, planMode) {
    var resolved = resolveCartVariant(variant, planMode);
    if (!resolved || !resolved.id) return null;
    var line = {
      id: Number(resolved.id),
      quantity: 1,
      properties: {
        _zenbodi_home_v2: "true"
      }
    };
    if (planMode === "sub" && product.planId) line.selling_plan = Number(product.planId);
    if (planMode === "sub" && product.giftVariantIds) line.properties._kids_cafe_welcome_kit = "true";
    // ZenBean Buy 3 / Buy 6: the same markers the landing-page widget stamps, so zen-gift-guard.js
    // keeps the gifts and the gift BXGY discounts zero them.
    if (resolved.gifts && resolved.gifts.length) {
      var word = variant && /bag/i.test(variant.title || "") ? "bags" : "boxes";
      line.properties._zenbean_welcome_kit = "true";
      line.properties.Includes = resolved.units + " " + word + " + free gifts: " + (resolved.giftNames || []).join(", ");
      line.properties._offer = "HOME";
    }
    return line;
  }

  function giftLines(product, planMode, variant) {
    var plan = variant && variant.plans ? resolveCartVariant(variant, planMode) : null;
    if (plan && plan.gifts && plan.gifts.length) {
      var lines = plan.gifts.map(function (id) {
        return {
          id: Number(id),
          quantity: 1,
          properties: {
            Type: "Free gift with your order",
            _zenbean_welcome_gift: "true",
            _zenbean_parent_variant: String(plan.id),
            _zenbodi_home_v2: "true"
          }
        };
      });
      // "Bundle Savings" + "Free Shipping" checkout lines, same as assets/zb-offer-v3.js cartExtras.
      (plan.extras || []).forEach(function (id) {
        lines.push({
          id: Number(id),
          quantity: 1,
          properties: {
            _zenbean_welcome_gift: "true",
            _zenbean_offer_line: "extra",
            _zenbean_parent_variant: String(plan.id),
            _zenbodi_home_v2: "true"
          }
        });
      });
      return lines;
    }
    if (planMode !== "sub" || !product || !Array.isArray(product.giftVariantIds)) return [];
    return product.giftVariantIds.map(function (id) {
      return {
        id: Number(id),
        quantity: 1,
        properties: {
          _kids_cafe_welcome_gift: "true",
          _kids_cafe_parent_variant: variant && variant.id ? String(variant.id) : "",
          _zenbodi_home_v2: "true"
        }
      };
    });
  }

  function addItems(items) {
    // Paid line first = the one Add to Cart; gifts go in without one (zen-cart-add.js).
    if (window.ZenCartAdd) return window.ZenCartAdd.add(items);
    return requestJson("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: JSON.stringify({ items: items })
    });
  }

  function goToCheckout() {
    window.location.assign("/checkout");
  }

  function handlePlanAdd(button) {
    var card = button.closest("[data-card]");
    var product = productFor(card);
    var variant = selectedVariant(card);
    var planMode = selectedPlan(card);
    var resolved = resolveCartVariant(variant, planMode);
    if (!product || !product.available || !variant || !resolved || !resolved.id) {
      setButtonState(button, "is-error", "Unavailable");
      return;
    }

    var primary = lineFor(product, variant, planMode);
    var items = primary ? [primary].concat(giftLines(product, planMode, variant)) : [];
    if (!items.length) {
      setButtonState(button, "is-error", "Unavailable");
      return;
    }

    var original = button.textContent;
    setButtonState(button, "is-loading", "Adding...");
    addItems(items)
      .then(function () {
        setButtonState(button, "is-added", "Checking out...");
        document.dispatchEvent(new CustomEvent("zenhome:cart-added", { detail: { items: items } }));
        goToCheckout();
      })
      .catch(function (error) {
        console.error(error);
        setButtonState(button, "is-error", "Try again");
        setTimeout(function () {
          setButtonState(button, "", original);
        }, 1800);
      });
  }

  function bundleItems(key) {
    var products = data.products;
    if (key === "athlete") {
      return [
        lineFor(products.creatine, products.creatine && products.creatine.variants.default, "once"),
        lineFor(products.protein, products.protein && products.protein.variants.vanilla, "once")
      ].filter(Boolean);
    }
    if (key === "family") {
      return [
        lineFor(products.kidsCafe, products.kidsCafe && products.kidsCafe.variants.chocolate, "once"),
        lineFor(products.zenbean, products.zenbean && products.zenbean.variants.ground, "once")
      ].filter(Boolean);
    }
    return [];
  }

  function handleBundleAdd(button) {
    var bundle = button.closest("[data-bundle]");
    var key = bundle && bundle.getAttribute("data-bundle");
    var items = bundleItems(key);
    if (!items.length) {
      setButtonState(button, "is-error", "Unavailable");
      return;
    }
    var original = button.textContent;
    setButtonState(button, "is-loading", "Adding...");
    addItems(items)
      .then(function () {
        setButtonState(button, "is-added", "Checking out...");
        goToCheckout();
      })
      .catch(function (error) {
        console.error(error);
        setButtonState(button, "is-error", "Try again");
        setTimeout(function () {
          setButtonState(button, "", original);
        }, 1800);
      });
  }

  function renderShopGrid() {
    var grid = document.getElementById("shop-grid");
    var filterRow = document.getElementById("filter-row");
    var empty = document.getElementById("empty-state");
    if (!grid || !filterRow) return;

    var products = [
      { key: "creatine", variant: "default", brand: "Zenbodi", category: "Creatine", title: "Creatine Monohydrate", best: true, image: data.products.creatine.variants.default.image },
      { key: "protein", variant: "vanilla", brand: "Zenbodi", category: "Protein", title: "Plant Protein, Vanilla", best: true, image: data.products.protein.variants.vanilla.image },
      { key: "protein", variant: "mint", brand: "Zenbodi", category: "Protein", title: "Plant Protein, Mint Chocolate", image: data.products.protein.variants.mint.image },
      { key: "protein", variant: "lemon", brand: "Zenbodi", category: "Protein", title: "Plant Protein, Lemon", image: data.products.protein.variants.lemon.image },
      { key: "protein", variant: "fruit", brand: "Zenbodi", category: "Protein", title: "Plant Protein, Fruit", image: data.products.protein.variants.fruit.image },
      { key: "kidsCafe", variant: "chocolate", brand: "Kids Cafe", category: "Kids Cafe", title: "Kids Cafe, Chocolate", best: true, image: data.products.kidsCafe.variants.chocolate && data.products.kidsCafe.variants.chocolate.image },
      { key: "kidsCafe", variant: "vanilla", brand: "Kids Cafe", category: "Kids Cafe", title: "Kids Cafe, Vanilla", image: data.products.kidsCafe.variants.vanilla && data.products.kidsCafe.variants.vanilla.image },
      { key: "kidsCafe", variant: "caramel", brand: "Kids Cafe", category: "Kids Cafe", title: "Kids Cafe, Caramel", image: data.products.kidsCafe.variants.caramel && data.products.kidsCafe.variants.caramel.image },
      { key: "zenbean", variant: "kcup", brand: "Zenbean", category: "Zenbean Coffee", title: "Zenbean Anti-Crash Brain Coffee, K-Cup Pods", best: true, image: data.products.zenbean.variants.kcup.image },
      { key: "zenbean", variant: "ground", brand: "Zenbean", category: "Zenbean Coffee", title: "Zenbean Anti-Crash Brain Coffee, Ground Bag", image: data.products.zenbean.variants.ground.image },
      { key: "alohaAwaken", variant: "orange", brand: "Aloha Zen", category: "Aloha Zen", title: "Aloha Zen Awaken, Variety Pack", best: true, image: data.products.alohaAwaken.variants.orange.image, unavailable: true },
      { key: "alohaUnwind", variant: "orange", brand: "Aloha Zen", category: "Aloha Zen", title: "Aloha Zen Unwind, Variety Pack", image: data.products.alohaUnwind.variants.orange.image, unavailable: true }
    ];

    var categories = [];
    products.forEach(function (product) {
      if (categories.indexOf(product.category) === -1) categories.push(product.category);
    });
    var filters = [{ key: "all", label: "All Products" }, { key: "best", label: "Best Sellers" }].concat(categories.map(function (category) {
      return { key: "cat:" + category, label: category };
    }));
    var active = "all";

    filterRow.innerHTML = filters.map(function (filter) {
      return '<button type="button" class="filter-pill' + (filter.key === active ? " is-active" : "") + '" data-filter="' + filter.key + '" role="tab" aria-selected="' + (filter.key === active ? "true" : "false") + '">' + filter.label + '</button>';
    }).join("");

    function visible(product) {
      if (active === "all") return true;
      if (active === "best") return !!product.best;
      if (active.indexOf("cat:") === 0) return product.category === active.slice(4);
      return true;
    }

    function card(item) {
      var product = data.products[item.key];
      var variant = product && product.variants[item.variant];
      var resolved = resolveCartVariant(variant, "once");
      var price = variant && variant.plans ? (resolved && resolved.price) : (product && product.planId ? variant && variant.subPrice : variant && variant.price);
      var compare = variant && variant.plans ? (resolved && resolved.compare) : (product && product.planId ? variant && variant.price : variant && variant.compare);
      var disabled = item.unavailable || !product || !product.available || !variant || !resolved || !resolved.id;
      var badge = item.best ? '<span class="pc-badge bestseller">Best seller</span>' : "";
      var url = variant && variant.url ? variant.url : product && product.url ? product.url : "#";
      return ''
        + '<article class="product-card" data-card data-product-key="' + item.key + '" data-selected-variant-key="' + item.variant + '">'
        + '<a class="pc-link" href="' + url + '" aria-label="' + item.title + '"><span class="pc-img">' + badge + '<img src="' + (item.image || "") + '" alt="' + item.title + '" loading="lazy" width="1200" height="1200"></span></a>'
        + '<div class="pc-body"><p class="pc-brand">' + item.brand + '</p><p class="pc-title"><a href="' + url + '">' + item.title + '</a></p>'
        + '<div class="pc-price-row"><span class="pc-price">' + (price || "") + '</span>' + (compare && compare !== price ? '<span class="pc-compare">' + compare + '</span>' : "") + '</div>'
        + (product && product.planId ? '<span class="pc-save">Subscription available</span>' : '')
        + '<button type="button" class="pc-add" data-shop-add ' + (disabled ? 'disabled' : '') + '>' + (disabled ? 'Coming soon' : 'Add to cart') + '</button></div></article>';
    }

    function render() {
      var list = products.filter(visible);
      grid.innerHTML = list.map(card).join("");
      if (empty) empty.hidden = list.length > 0;
    }

    filterRow.addEventListener("click", function (event) {
      var button = event.target.closest("[data-filter]");
      if (!button) return;
      active = button.getAttribute("data-filter");
      filterRow.querySelectorAll("[data-filter]").forEach(function (node) {
        var on = node === button;
        node.classList.toggle("is-active", on);
        node.setAttribute("aria-selected", on ? "true" : "false");
      });
      render();
    });

    render();
  }

  document.addEventListener("click", function (event) {
    var variantButton = event.target.closest("[data-product-variant-key]");
    if (variantButton) {
      var card = variantButton.closest("[data-card]");
      if (card) {
        card.setAttribute("data-selected-variant-key", variantButton.getAttribute("data-product-variant-key"));
        updateCard(card);
      }
    }

    var planButton = event.target.closest("[data-plan-group] .plan-opt");
    if (planButton) {
      var planGroup = planButton.closest("[data-plan-group]");
      var planCard = planButton.closest("[data-card]");
      if (planGroup && planCard) {
        planGroup.querySelectorAll(".plan-opt").forEach(function (opt) {
          opt.classList.toggle("is-selected", opt === planButton);
        });
        updateCard(planCard);
      }
    }

    var add = event.target.closest(".plan-add:not([disabled])");
    if (add && add.closest("[data-card]")) {
      handlePlanAdd(add);
      return;
    }

    var bundle = event.target.closest(".bundle-cta:not([disabled])");
    if (bundle) {
      handleBundleAdd(bundle);
      return;
    }

    var shopAdd = event.target.closest("[data-shop-add]:not([disabled])");
    if (shopAdd) {
      var card = shopAdd.closest("[data-card]");
      var product = productFor(card);
      var variant = selectedVariant(card);
      var mode = product && product.planId ? "sub" : "once";
      var line = lineFor(product, variant, mode);
      var items = line ? [line].concat(giftLines(product, mode, variant)) : [];
      var original = shopAdd.textContent;
      setButtonState(shopAdd, "is-loading", "Adding...");
      addItems(items)
        .then(function () {
          setButtonState(shopAdd, "is-added", "Checking out...");
          goToCheckout();
        })
        .catch(function (error) {
          console.error(error);
          setButtonState(shopAdd, "is-error", "Try again");
          setTimeout(function () {
            setButtonState(shopAdd, "", original);
          }, 1800);
        });
    }
  });

  document.querySelectorAll("[data-card][data-product-key]").forEach(updateCard);
  renderShopGrid();
})();
